export default (body, required = [], customFunction) => {
	const hasAll = required.every((key) =>
		Object.keys(body)
			.filter((key) => body[key])
			.filter(Boolean)
			.includes(key)
	);

	const custom = typeof customFunction === 'function' ? customFunction() : true;

	return hasAll && custom;
};

export const useRequiredBeta = (body, required = [], customFunction) => {
	const hasAll = required.every((key) =>
		Object.keys(body)
			.filter((key) => body[key])
			.filter(Boolean)
			.filter((key) => body[key]?.value)
			.includes(key)
	);

	const custom = typeof customFunction === 'function' ? customFunction() : true;

	return hasAll && custom;
};
